import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import TextField from '../../widgets/TextField';
import CheckBoxField from '../../widgets/CheckBoxField';

import './login-form.scss';

class LoginForm extends PureComponent {
  render() {
    return (
      <div className="login-form-container">
        <h3>Вход в личный кабинет</h3>

        <form className="login-form" onSubmit={this.props.onSubmit}>
          <TextField
            id="loginForm_login"
            label="Логин"
            type="text"
            name="login"
            value={this.props.login}
            error={this.props.loginError}
            onChange={this.props.onFieldChange}
          />
          <TextField
            id="loginForm_password"
            label="Пароль"
            type="password"
            name="password"
            value={this.props.password}
            error={this.props.passwordError}
            onChange={this.props.onFieldChange}
          />

          <CheckBoxField
            id="loginForm_remember"
            label="запомнить меня"
            name="remember"
            checked={this.props.remember}
            error={this.props.rememberError}
            onChange={this.props.onRememberChange}
          />

          <div className="submit-container">
            <button type="submit" className="btn solid-white">
              <div className="btn-flex">
                <em>Личный кабинет<span className="icon">→</span></em>
                Войти
              </div>
            </button>
          </div>
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  login: PropTypes.string.isRequired,
  loginError: PropTypes.string,
  password: PropTypes.string.isRequired,
  passwordError: PropTypes.string,
  remember: PropTypes.bool.isRequired,
  rememberError: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  onRememberChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/LoginForm.js